import intl from 'preact-i18n';
import Dcc from './components/dcc';
import definition from './intl.json';

export const DccWidget = intl(Dcc, { scope: 'dccv2', definition });
export default DccWidget;
